
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'clinical_classification_of_vulvovaginal_candidiasis',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/clinical_classification_of_vulvovaginal_candidiasis.vue